"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeHTMLEntities = void 0;
// Source: https://stackoverflow.com/a/9609450
const element = document.createElement("div");
function decodeHTMLEntities(str) {
    if (str && typeof str === "string") {
        // strip script/html tags
        str = str.replace(/<script[^>]*>([\S\s]*?)<\/script>/gim, "");
        str = str.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gim, "");
        element.innerHTML = str;
        str = element.textContent;
        element.textContent = "";
    }
    return str;
}
exports.decodeHTMLEntities = decodeHTMLEntities;
//# sourceMappingURL=decodeHtmlEntities.js.map